<template>
    <div>
        <!-- 功能 -->
        <div class="header-menu">
            <el-form :inline="true" label-width="100px">
            <el-form-item label="下载人：">
                <el-select class="select" filterable clearable v-model="dowonloadName" placeholder="请选择下载人"
                style="width:100%;">
                <el-option style="margin-left: 10px" v-for="teacher in teachers" :key="teacher.id"
                    :label="teacher.realname" :value="teacher.id">
                </el-option>
                </el-select>
            </el-form-item>
            <el-row>
                <el-col :span="12" :push="12" style="text-align: right;">
                    <el-button type="primary" @click="handleApprover" class="btns" size="small">下载次数管理</el-button>
                    <el-button type="primary"  @click="searchStudent" size="small" class="btns">查询</el-button>
                    <el-button type="primary" @click="handleClearList" class="btns" size="small" >清除</el-button>
                </el-col>
            </el-row>
            </el-form>
        </div>

      <div style="margin-top: 20px;">
        <el-table
            :data="DownloadNumStatisticsList"
            border
            style="width: 100%">
            <el-table-column
            fixed
            prop="adminName"
            label="下载人"
            >
            </el-table-column> 
            <el-table-column
            prop="dailyDownloadCount"
            label="当天下载次数"
            >
            </el-table-column>
            <el-table-column
            prop="weekDownloadCount"
            label="本周下载次数"
          >
            </el-table-column>
            <el-table-column
            prop="monthDownloadCount"
            label="本月下载次数"
          >
            </el-table-column>
            <el-table-column
            fixed="right"
            label="操作"
            width="120">
            <template slot-scope="scope">
                <el-button @click="handleClick(scope.row)" type="text" size="small" >详情</el-button>
            </template>
            </el-table-column>
        </el-table>
      </div>


    <el-pagination
        @size-change="handleSizeChanges"
        @current-change="handleCurrentChanges"
        :current-page.sync="dowfFromData.pageNo"
        :page-size="dowfFromData.pageSize"
        :total="dowfFromData.allTotal"
        layout="prev, pager, next,sizes,jumper">
    </el-pagination>

  <el-dialog
      title="下载详情"
      append-to-body
      :visible.sync="detailsDialogVisibles"
      width="60%"
      :before-close="handledialogVisiblesdetails">
        <el-form :inline="true" >
            <el-form-item label="下载时间:" style="display: flex; ">
              <el-date-picker v-model="detailfFromData.timers" type="daterange" value-format="yyyy-MM-dd" range-separator="至"
                start-placeholder="开始日期" end-placeholder="结束日期"></el-date-picker>
            </el-form-item>
            <el-row>
                <el-col :span="12" :push="12" style="text-align: right;margin-bottom: 20px">
                    <el-button type="primary"  @click="searchStudent3" size="small" class="btns">查询</el-button>
                    <el-button type="primary" @click="handleClearList3" class="btns" size="small" >清除</el-button>
                </el-col>
            </el-row>
        </el-form>
      
      <el-table
            :data="detailDownloadNumStatisticsList"
            border
            style="width: 100%">
            <el-table-column
            fixed
            prop="adminName"
            label="下载人"
            >
            </el-table-column> 
            <el-table-column
            prop="fileName"
            label="文件名字"
            >
            </el-table-column>
            <el-table-column
            prop="folderName"
            label="文件目录"
          >
            </el-table-column>
            <el-table-column
            prop="downloadFileTime"
            label="下载时间"
          >
            </el-table-column>
            <el-table-column
            fixed="right"
            label="操作"
            width="120">
            <template slot-scope="scope" >
                <el-button @click="handleClickFile(scope.row)" type="text" size="small" >详情</el-button>
            </template>
          </el-table-column>  
        </el-table>

      <el-pagination
        @size-change="handleSizeChangess"
        @current-change="handleCurrentChangess"
        :current-page.sync="detailfFromData.pageNo"
        :page-size="detailfFromData.pageSize"
        :total="detailfFromData.allTotal"
        layout="prev, pager, next,sizes,jumper">
      </el-pagination>


  </el-dialog>

    <el-dialog
      title="下载次数管理"
      append-to-body
      :visible.sync="dialogVisibles"
      width="60%"
      :before-close="handledialogVisibles">
        <el-form :inline="true" >
            <el-form-item label="下载人：">
                <el-select class="select" filterable clearable v-model="dowonloadName2" placeholder="请选择下载人"
                style="width:100%;">
                <el-option style="margin-left: 10px" v-for="teacher in teachers" :key="teacher.id"
                    :label="teacher.realname" :value="teacher.id">
                </el-option>
                </el-select>
            </el-form-item>
            <el-row>
                <el-col :span="12" :push="12" style="text-align: right;margin-bottom: 20px">
                    <el-button type="primary"  @click="searchStudent2" size="small" class="btns">查询</el-button>
                    <el-button type="primary" @click="handleClearList2" class="btns" size="small" >清除</el-button>
                </el-col>
            </el-row>
        </el-form>
      <el-table
        :data="downList"
        border
        tyle="width: 100% ;">
      <el-table-column  prop="adminName"label="下载人">
      </el-table-column> 
      <el-table-column prop="limitationType" label="周期">
            <template slot-scope="scope">
            <span v-if="scope.row.limitationType === 0">天</span>
            <span v-if="scope.row.limitationType === 1">周</span>
            <span v-if="scope.row.limitationType === 2">月</span>
            </template>
      </el-table-column>
      <el-table-column prop="limitationNum" label="周期内可下载次数" ></el-table-column>
      <el-table-column label="操作" width="120">
            <template slot-scope="scope">
                <el-button @click="handleClickDownload(scope.row)" type="text" size="small" >编辑</el-button>
            </template>
      </el-table-column>
    </el-table>

      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page.sync="fromData.pageNo"
        :page-size="fromData.pageSize"
        :total="fromData.allTotal"
        layout="prev, pager, next,sizes,jumper">
      </el-pagination>


    </el-dialog>

    <el-dialog
      title="编辑"
      append-to-body
      :visible.sync="dialogApprover"
      width="60%"
      :before-close="handledialogApprover"                                                       >
    <el-form :inline="true"label-width="100px">
          <el-form-item label="下载人:">
              <el-input placeholder="请输入名字" v-model="editDownList.adminName" clearable disabled></el-input>
          </el-form-item>
          <el-form-item label="周期：" label-width="100px">
            <el-select style="width: 100%"  v-model="editDownList.limitationType"  placeholder="请选择" filterable>
                <el-option
                style="margin-left: 10px"
                v-for="item in cycleList"
                :key="item.value"
                :label="item.text"
                :value="item.value">
                </el-option>
            </el-select>          
          </el-form-item>
            <el-form-item label="下载次数:">
          <el-input placeholder="次数" v-model="editDownList.limitationNum" clearable></el-input>
        </el-form-item>
      </el-form>

      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogApprover = false, Approverpepu =[]">取 消</el-button>
        <el-button type="primary" @click="okTouch">确 定</el-button>
      </span>
    </el-dialog>

    <el-dialog
      title="下载列表"
      append-to-body
      :visible.sync="dialogFileList"
      width="60%"
      :before-close="handledialogApproverFileList"                                                       >
            <el-table
            :data="dataFileList"
            border
            style="width: 100%">
            <el-table-column
            fixed
            prop="fileName"
            label="下载列表"
            >
             <template slot-scope="scope">
              <span style="color:#409EFF"  @click="handleClickDep(scope.row)">{{ scope.row.fileName }}</span>
            </template>
            </el-table-column> 
            
        </el-table>

    </el-dialog>



    <el-dialog title="预览图片" width="50%" style="padding: 0px 50px;" :visible.sync="showInfo" :before-close="showshowInfoViewInfoCler" :close-on-click-modal="false">
      <Guciya v-if="showInfo" :url="urls" ></Guciya>
    </el-dialog>

    <el-dialog title="预览" width="60%" style="padding: 0px 50px;" :visible.sync="showImgDing" :before-close="showImgDingClers5" :close-on-click-modal="false">
        <div style="margin-bottom: 20px;">
            <!-- <el-button :theme="'default'"  type="submit" :title="'基础按钮'" @click.stop="handleDownload1" class="mr10"> 下 载</el-button> -->
        </div>
        <div>
            <img :src="showImgDingurlsss" :alt="showImgDingurlsss" style="width: 100%;">
        </div>
    </el-dialog>

    <el-dialog title="预览" width="60%" style="padding: 0px 50px;" :visible.sync="showInfos" :before-close="showshowInfoViewInfoClers" :close-on-click-modal="false">
        <!-- <el-button :theme="'default'"  type="submit" :title="'基础按钮'" @click.stop="handleDownload" class="mr10"> 下 载</el-button> -->
        <!-- <el-button :theme="'default'"  type="submit" :title="'基础按钮'"  class="mr10">暂无预览~</el-button> -->
        <GuciYa-VueOfficeDocx :src="docxContent" ref="docxEditor" :options="editorOptions"></GuciYa-VueOfficeDocx>
    </el-dialog>
      
    </div>
</template>

<script>
import axios from "axios";
import apiBaseUrl from "../../config/api";
import loadingUtils from "../utils/loading";
import { getSubject,} from "@/api/firstClassApi";
import Guciya from "../InterviewManagement/components/Guciya-compoents";



export default {
  name: "DownloadManagement",
   components: { Guciya },
  props: {  },
  data(){
    return {
      dialogFileList:false,
      detailfFromData: {
        pageNo: 1,
        pageSize: 10,
        allTotal: 0,
        adminId: '',
        timers:[],
      },
      detailsDialogVisibles:false,
      fromData: {
        pageNo: 1,
        pageSize: 10,
        allTotal:0,
      },
      dowfFromData: {
        pageNo: 1,
        pageSize: 10,
        allTotal:0,
      },
      downList: '',
      editDownList: {
        adminName: '',
        limitationType: '',
        limitationNum:''
      },
      dialogApprover:false,
      approverType:1,
      dialogVisibles:false,
      commitRemark1:'',
      teachers:[],
      dowonloadName:'',
      dowonloadName2:'',
      

      tableData: [],
      approvalId:'',
      Approverpepu:[],
      cycleList: [
        {value:0,text:'天'},
        {value:1,text:'周'},
        {value:2,text:'月'},
      ],
      DownloadNumStatisticsList: [],
      detailDownloadNumStatisticsList:[],

      showInfo:false,
      urls:'',
      docxContent:'',
      showInfos:false,
      showImgDingurlsss:'',
      showImgDing:false,

      editorOptions: {
        toolbar: true,
        width: '800px',
        height: '600px'
      },
      dataFileList: [],

      adminId:'',    
      };
  },
  mounted(){

    axios.get(`${apiBaseUrl}/questionnaire/queryCreator`, {
      headers: {
        'authorization': sessionStorage.getItem('tokenInfo')
      }
    }) // 请替换为你的API URL
      .then(response => {
        this.teachers = [...response.data.data]
      })
      .catch(error => {
        console.error(error);
    });

      this.getDownloadNumList()
      this.getDownloadNumStatisticsList()
 
  },
  methods:{

    getDownloadNumList(){
      let data = {
        adminId:this.dowonloadName2,
        pageNo:this.fromData.pageNo,
        pageSize:this.fromData.pageSize
      }
      axios.post(`${apiBaseUrl}/downloadNum/getDownloadNumList`,data,{
        headers:{
        'authorization': sessionStorage.getItem('tokenInfo')
        }
      }).then((res) => {
        if (res.data.code === 200) {
          this.downList = res.data.data.records
          this.fromData.allTotal =res.data.data.total
        } else {
          this.$message.error(res.data.message)
        }
        
      })
    },

    getDownloadNumStatisticsList() {
      let data = {
        adminId:this.dowonloadName,
        pageNo:this.dowfFromData.pageNo,
        pageSize:this.dowfFromData.pageSize
      }
      axios.post(`${apiBaseUrl}/downloadNum/downloadNumStatisticsList`,data,{
        headers:{
        'authorization': sessionStorage.getItem('tokenInfo')
        }
      }).then((res) => {
        if (res.data.code === 200) {
          
          this.DownloadNumStatisticsList = res.data.data.records
          this.dowfFromData.allTotal =res.data.data.total

        } else {
          this.$message.error(res.data.message)
        }
        
      })
    },

    handleClick(row) {
      
      this.detailsDialogVisibles = true
      this.adminId = row.adminId

      this.getAdminFileDownloadList()
   
    },

    getAdminFileDownloadList() {
        let data = {
        adminId:this.adminId,
        pageNo:this.detailfFromData.pageNo,
        pageSize:this.detailfFromData.pageSize,
        startTime: this.detailfFromData.timers[0] || '',
        endTime:this.detailfFromData.timers[1] || '',
      }
      axios.post(`${apiBaseUrl}/fileDownload/getAdminFileDownloadList`,data,{
        headers:{
        'authorization': sessionStorage.getItem('tokenInfo')
        }
      }).then((res) => {
        if (res.data.code === 200) {
          this.detailDownloadNumStatisticsList = res.data.data.records
          
          this.detailfFromData.allTotal = res.data.data.total
        } else {
          this.$message.error(res.data.message)
        }
        
      })
    },
    handleClickDownload(row) {
      this.editDownList = row
      this.adminName = row.adminName
      this.limitationType = row.limitationType
      this.limitationNum = row.limitationNum
      this.dialogApprover = true
    },
    searchStudent(){
      this.dowfFromData.pageNo = 1
      this.getDownloadNumStatisticsList()
    },
    searchStudent2(){
      this.fromData.pageNo = 1
      this.getDownloadNumList()
    },
    searchStudent3() {
      this.detailfFromData.pageNo = 1
      this.getAdminFileDownloadList() 
    },
    handleClearList(){
      this.dowonloadName = ""
      this.getDownloadNumStatisticsList()
    },
    handleClearList2(){
      this.dowonloadName2 = ""
      this.getDownloadNumList()
    },
    handleClearList3() {
      this.detailfFromData.timers = []
      this.getAdminFileDownloadList() 
    },
    handledialogVisibles(){
      this.dialogVisibles = false
    },
    handledialogVisiblesdetails() {
      this.detailsDialogVisibles = false
    },
    handleApprover(){
      this.dialogVisibles = true

    },
    handledialogApprover() {
      this.dialogApprover = false
    },
    
    handledialogApproverFileList() {
      this.dialogFileList = false
    },

  handleSizeChange(size){
      this.fromData.pageSize = size
      this.getDownloadNumList()
    },
    handleSizeChangess(size) {
    this.detailfFromData.pageSize = size
    this.getAdminFileDownloadList()
      
  },
  handleSizeChanges(size) {
      this.dowfFromData.pageSize = size
      this.getDownloadNumStatisticsList()
  },
  handleCurrentChanges(size) {
    this.dowfFromData.pageNo = size
    this.getDownloadNumStatisticsList()
  },

  handleCurrentChange(size){
      this.fromData.pageNo = size
      this.getDownloadNumList()
    },
  handleCurrentChangess(size) {
    this.detailfFromData.pageNo = size
    this.getAdminFileDownloadList()
  },
  okTouch() {
      let data = {
        id:this.editDownList.id,
        adminId: this.editDownList.adminId,
        limitationType: this.editDownList.limitationType,
        limitationNum:this.editDownList.limitationNum,
      }
      axios.put(`${apiBaseUrl}/downloadNum/editDownloadNum`,data,{
        headers:{
        'authorization': sessionStorage.getItem('tokenInfo')
        }
      }).then((res) => {
      this.dialogApprover = false
        if (res.data.code === 200) {
          this.$message.success(res.data.message)
        } else {
          this.$message.error(res.data.message)
        }     
      })
    },
    handleClickFile(row) {
    this.dialogFileList = true
      
    this.dataFileList = row.fileList
  },

   handleClickDep(row){
    
    const replacedString = row.fileUrl.replace('+', '%2B')
      const replacedStrings = this.upgradeToHttps(replacedString)
      row.fileUrl = replacedStrings


          if(this.issoN(row.fileUrl)){


            let JsonUrls = JSON.parse(row.fileUrl)
            let JsonUrl = ''
            if(JsonUrls && Array.isArray(JsonUrls)){
                JsonUrl = JsonUrls[0].url
            }else{
                JsonUrl = JsonUrls.url
            }

            if(JsonUrl){
              if(this.getFileName(JsonUrl) === ".pdf"){
                    this.urls = JsonUrl
                    this.showInfo = true
                }else if (this.getFileName(JsonUrl) === ".docx" || this.getFileName(JsonUrl) === ".doc"){
                    this.docxContent = JsonUrl
                    this.showInfos = true
                }else{
                    if(this.getFileName(JsonUrl) === ".jpg" || this.getFileName(JsonUrl) === ".png"){
                        this.showImgDingurlsss = JsonUrl
                        this.showImgDing = true
                    }
                    else{
                        this.$message({type: 'warning', message: '请检查是否为有效的文件类型~' })
                    }
                }
            }

          }else{
            if(row.fileUrl){
              if(this.getFileName(row.fileUrl) === ".pdf"){
                    this.urls = row.fileUrl
                    this.showInfo = true
                }else if (this.getFileName(row.fileUrl) === ".docx" || this.getFileName(row.fileUrl) === ".doc"){
                    this.docxContent = row.fileUrl
                    this.showInfos = true
                }else{
                    if(this.getFileName(row.fileUrl) === ".jpg" || this.getFileName(row.fileUrl) === ".png"){
                        this.showImgDingurlsss = row.fileUrl
                        this.showImgDing = true
                    }
                    else{
                        this.$message({type: 'warning', message: '请检查是否为有效的文件类型~' })
                    }
                }
            }
          }
      
  },
  getFileName(name) { return name.substring(name.lastIndexOf("."))},
  showshowInfoViewInfoCler(){
      this.showInfo = false
  },
  showImgDingClers5(){
      this.showImgDing = false
      this.showImgDingurlsss = ''
  },
  showshowInfoViewInfoClers(){
        this.showInfos = false
    },
  upgradeToHttps(urlString) {
    const hasHttps = urlString.includes('https://');

    if (!hasHttps && urlString.includes('http://')) {
      return urlString.replace('http://', 'https://');
    } else {
      return urlString;
    }
    },
  issoN(str){
        try {
            JSON.parse(str)
            return true
        } catch(e){
            return false
        }
  },
  },

}

</script>


<style lang="less" scoped>



</style>



// WEBPACK FOOTER //
// src/FileSpace/DownloadManagement.vue